function scrollToTop() {
    $('.js-scroll-to-top').on('click', function() {
        const el = $('body');
        scrollToEl(el, 0, 1000);
    })

    $(window).on('scroll resize load', function() {
        if ($(window).scrollTop() > $(window).height()) {
            $('.c-scroll-to-top').addClass('is-active');
        } else {
            $('.c-scroll-to-top').removeClass('is-active');
        }
    })
}

function scrollToEl(el, offset = 0, speed = 2000) {
	let scrollTop;
	if (el instanceof jQuery) {
		scrollTop = offset ? el.offset().top + offset : el.offset().top;
	} else {
		scrollTop = offset ? $(el).offset().top + offset : $(el).offset().top;
	}

	$([document.documentElement, document.body]).animate(
		{
			scrollTop: scrollTop
		},
		speed
	);
}


/**
 * Cookies
 */

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
}

function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const cookie = cookies.find(cookie => cookie.startsWith(nameEQ));
    return cookie ? cookie.substring(nameEQ.length) : null;
}